import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RRICustomBatchOptionSettings } from '../../../common/interfaces/table/batch-options.interface';

@Component({
  selector: 'rr-table-custom-batch-options',
  templateUrl: './table-custom-batch-options.component.html',
  styleUrls: ['./table-custom-batch-options.component.scss'],
})
export class TableCustomBatchOptionsComponent<T> {
  @Input() batchOptionsSettings: RRICustomBatchOptionSettings<T>[];
  @Output() batchOptionClicked: EventEmitter<RRICustomBatchOptionSettings<T>> =
    new EventEmitter();

  constructor() {}

  public onBatchOptionClicked(option: RRICustomBatchOptionSettings<T>): void {
    this.batchOptionClicked.emit(option);
  }
}
